import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux'
import R from 'ramda'

export const initialState = {
  items: {}
}

const items = handleActions({
  FETCH_PLACE_FULFILLED: (state, { payload }) => ({
    ...state,
    [payload.id]: payload
  }),
  FETCH_PLACES_FULFILLED: (state, { payload }) => R.merge(
    state,
    R.indexBy(R.prop('id'), payload)
  )
}, initialState.items)

export default combineReducers({
  items
})

export const getPlaces = R.path(['places', 'items'])
export const getPlaceById = (state, id) =>
  R.compose(
    R.prop(id),
    getPlaces
  )(state)



// WEBPACK FOOTER //
// ./src/reducers/places.js